import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretMinimizeDiagonal = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 10L20.9999 9.03724L18.012 6.01862L15.024 3L14 3L14.0001 10L21 10Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M10 21L9.03724 20.9999L6.01862 18.012L3 15.024L3 14L10 14.0001L10 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconCaretMinimizeDiagonal.js.map